import React from 'react';
import { Bitcoin, Shield, Globe, Lock } from 'lucide-react';

function Features({ layout = 'horizontal' }) {
  const features = [
    {
      icon: <Bitcoin size={28} />,
      color: 'orange',
      title: 'Bitcoin payments',
      desc: 'Enjoy secure and KYC-free borderless payments with BTC! We value your privacy and promote cryptocurrencies.'
    },
    {
      icon: <Shield size={28} />,
      color: 'teal',
      title: 'Stablecoin payments: USDT and USDC',
      desc: 'Volatility-free crypto payments with USDT and USDC. We accept USDT on Ethereum and Tron networks, USDC on Ethereum network.'
    },
    {
      icon: <Globe size={28} />,
      color: 'pink',
      title: 'Worldwide Service',
      desc: 'We accept samples globally over the world.'
    },
    {
      icon: <Lock size={28} />,
      color: 'blue',
      title: 'Anonymous & Secure',
      desc: '100 % private, encrypted reports.'
    }
  ];

  if (layout === 'vertical') {
    return (
      <div className="features-vertical" data-testid="features-vertical">
        {features.map((f, i) => (
          <div key={i} className="feature-item-vertical" style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', marginBottom: '24px' }}>
            <div className={`feature-icon ${f.color}`} style={{ color: 'white', flexShrink: 0 }}>
              {f.icon}
            </div>
            <div>
              <h4 style={{ fontWeight: 700, fontSize: '16px', marginBottom: '6px' }}>{f.title}</h4>
              <p style={{ fontSize: '14px', color: '#666', lineHeight: 1.6 }}>{f.desc}</p>
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <section className="features-section" data-testid="features-section">
      <div className="container">
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className={`feature-icon ${f.color}`} style={{ color: 'white' }}>
                {f.icon}
              </div>
              <h4>{f.title}</h4>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
